import { MessageCircle, Phone, Mail } from "lucide-react";
import { CONTACT, track } from "@/lib/api";

export default function ContactBar({ context = "", variant = "row" }) {
  const items = [
    { key: "whatsapp", href: CONTACT.whatsapp, ext: true, icon: MessageCircle, label: "WhatsApp", ev: "contact_whatsapp" },
    { key: "phone", href: CONTACT.phoneHref, icon: Phone, label: CONTACT.phone, ev: "contact_phone" },
    { key: "email", href: CONTACT.emailHref, icon: Mail, label: CONTACT.email, ev: "contact_email" },
  ];
  return (
    <div className={variant === "row" ? "flex flex-wrap gap-3" : "flex flex-col gap-3"}>
      {items.map((it) => {
        const Icon = it.icon;
        return (
          <a key={it.key} href={it.href} target={it.ext ? "_blank" : undefined} rel="noreferrer"
            onClick={() => track(it.ev, context)} data-testid={`contact-${it.key}`}
            className="flex items-center gap-3 px-5 py-3 border border-white/15 hover:border-gold hover:bg-gold/5 transition-colors text-white/80 hover:text-white">
            <Icon className="w-5 h-5 text-gold" /> <span className="text-sm font-medium">{it.label}</span>
          </a>
        );
      })}
    </div>
  );
}
